import Vue from 'vue'
import Router from 'vue-router'

// meta 部分字段解析
// menuShow: true, 在导航栏中显示（默认为false）
// needPermission: true, 需登录后才可进入 (默认为false)
// headerHide: true 隐藏导航栏 (默认为false)
// footerHide: true 隐藏底部栏 (默认为false)
Vue.use(Router)
export const constantRouterMap = [
  {
    path: '/',
    name: 'home',
    component: (resolve) => {
      require(['@/views/home/index.vue'], resolve)
    },
    meta: {
      title: 'router.home.title',
      name: 'router.home.name',
      desc: 'router.home.desc',
      icon: '',
      menuShow: true,
      footerHide: true
    }
  },
  {
    path: '/signin',
    name: 'signin',
    component: (resolve) => {
      require(['@/views/login/index.vue'], resolve)
    },
    meta: {
      headerHide: true
    }
  },
  {
    path: '/signup',
    name: 'signup',
    component: (resolve) => {
      require(['@/views/login/signup.vue'], resolve)
    },
    meta: {
      headerHide: true
    }
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: (resolve) => {
      require(['@/views/login/forgotPsw.vue'], resolve)
    },
    meta: {
      headerHide: true
    }
  },
  {
    path: '/delete',
    name: 'delete',
    component: (resolve) => {
      require(['@/views/login/deleteAccount.vue'], resolve)
    },
    meta: {
      noRedirect: true,
      headerHide: true
    }
  },
  {
    path: '/case',
    name: 'case',
    redirect: '/case/paddy',
    component: (resolve) => {
      require(['@/views/case/index.vue'], resolve)
    },
    meta: {
      title: 'router.case.title',
      name: 'router.case.name',
      desc: 'router.case.desc',
      icon: '',
      menuShow: true
    },
    children: [
      {
        path: '/case/paddy',
        name: 'paddy',
        component: (resolve) => {
          require(['@/views/case/paddy.vue'], resolve)
        },
        meta: {
          title: 'router.paddy.title',
          name: 'router.paddy.name',
          desc: 'router.paddy.desc',
          icon: 'nav_icon_paddy.png',
          menuShow: true
        }
      },
      {
        path: '/case/cotton',
        name: 'cotton',
        component: (resolve) => {
          require(['@/views/case/cotton.vue'], resolve)
        },
        meta: {
          title: 'router.cotton.title',
          name: 'router.cotton.name',
          desc: 'router.cotton.desc',
          icon: 'nav_icon_cotton.png',
          menuShow: true
        }
      },
      {
        path: '/case/trace',
        name: 'trace',
        component: (resolve) => {
          require(['@/views/case/trace.vue'], resolve)
        },
        meta: {
          title: 'router.trace.title',
          name: 'router.trace.name',
          desc: 'router.trace.desc',
          icon: 'nav_icon_trace.png',
          menuShow: true
        }
      }
    ]
  },
  {
    path: '/prod',
    name: 'products',
    component: (resolve) => {
      require(['@/views/fm/index.vue'], resolve)
    },
    meta: {
      title: 'router.products.title',
      name: 'router.products.name',
      desc: 'router.products.desc',
      icon: '',
      menuShow: true
    },
    children: [
      {
        path: '/prod/sensor',
        name: 'sensor',
        redirect: '/prod/products',
        component: (resolve) => {
          require(['@/views/fm/prods/index.vue'], resolve)
        },
        meta: {
          name: 'router.sensor.name',
          desc: 'router.sensor.desc',
          icon: '',
          menuShow: true
        },
        children: [
          {
            path: '/prod/IHUB1S',
            name: 'IHUB1S',
            component: (resolve) => {
              require(['@/views/fm/prods/intelligentBox.vue'], resolve)
            },
            meta: {
              title: 'router.IHUB1S.title',
              name: 'router.IHUB1S.name',
              desc: 'router.IHUB1S.desc',
              icon: 'nav_icon_ihub1s.png',
              menuShow: true
            }
          },
          {
            path: '/prod/IFC16S',
            name: 'IFC16S',
            component: (resolve) => {
              require(['@/views/fm/prods/farmCam.vue'], resolve)
            },
            meta: {
              title: 'router.IFC16S.title',
              name: 'router.IFC16S.name',
              desc: 'router.IFC16S.desc',
              icon: 'nav_icon_ifc16s.png',
              menuShow: true
            }
          },
          {
            path: '/prod/ISM50',
            name: 'ISM50',
            component: (resolve) => {
              require(['@/views/fm/prods/soilMate.vue'], resolve)
            },
            meta: {
              title: 'router.ISM50.title',
              name: 'router.ISM50.name',
              desc: 'router.ISM50.desc',
              icon: 'nav_icon_ism50.png',
              menuShow: true
            }
          },
          {
            path: '/prod/IWS7',
            name: 'IWS7',
            component: (resolve) => {
              require(['@/views/fm/prods/weatherStation.vue'], resolve)
            },
            meta: {
              title: 'router.IWS7.title',
              name: 'router.IWS7.name',
              desc: 'router.IWS7.desc',
              icon: 'nav_icon_iws7.png',
              menuShow: true
            }
          },
          {
            path: '/prod/IWS3',
            name: 'IWS3',
            component: (resolve) => {
              require(['@/views/fm/prods/hydroThermo.vue'], resolve)
            },
            meta: {
              title: 'router.IWS3.title',
              name: 'router.IWS3.name',
              desc: 'router.IWS3.desc',
              icon: 'nav_icon_iws3.png',
              menuShow: true
            }
          },
          {
            path: '/prod/IFC16',
            name: 'IFC16',
            component: (resolve) => {
              require(['@/views/fm/prods/fc1.vue'], resolve)
            },
            meta: {
              title: 'router.IFC16.title',
              name: 'router.IFC16.name',
              desc: 'router.IFC16.desc',
              icon: 'nav_icon_ifc16s.png'
            }
          },
          {
            path: '/prod/products',
            name: 'all',
            component: (resolve) => {
              require(['@/views/fm/prods/products.vue'], resolve)
            },
            meta: {
              title: 'router.all.title',
              name: 'router.all.name',
              desc: 'router.all.desc',
              icon: 'nav_icon_more.png',
              menuShow: true
            }
          }
        ]
      },
      {
        path: '/prod/parts',
        name: 'parts',
        redirect: '/prod/solar',
        component: (resolve) => {
          require(['@/views/fm/parts/index.vue'], resolve)
        },
        meta: {
          name: 'router.parts.name',
          desc: 'router.parts.desc',
          icon: '',
          menuShow: true
        },
        children: [
          {
            path: '/prod/solar',
            name: 'solar',
            component: (resolve) => {
              require(['@/views/fm/parts/solar.vue'], resolve)
            },
            meta: {
              title: 'router.solar.title',
              name: 'router.solar.name',
              desc: 'router.solar.desc',
              icon: 'nav_icon_solar.png',
              menuShow: true
            }
          },
          {
            path: '/prod/fixedbanister',
            name: 'fixedbanister',
            component: (resolve) => {
              require(['@/views/fm/parts/fixedbanister.vue'], resolve)
            },
            meta: {
              title: 'router.fixedbanister.title',
              name: 'router.fixedbanister.name',
              desc: 'router.fixedbanister.desc',
              icon: 'nav_icon_fixedbanister.png',
              menuShow: true
            }
          },
          {
            path: '/prod/wire',
            name: 'wire',
            component: (resolve) => {
              require(['@/views/fm/parts/wire.vue'], resolve)
            },
            meta: {
              title: 'router.wire.title',
              name: 'router.wire.name',
              desc: 'router.wire.desc',
              icon: 'nav_icon_wire.png',
              menuShow: true
            }
          },
          {
            path: '/prod/products',
            name: 'all',
            component: (resolve) => {
              require(['@/views/fm/prods/products.vue'], resolve)
            },
            meta: {
              title: 'router.all.title',
              name: 'router.all.name',
              desc: 'router.all.desc',
              icon: 'nav_icon_more.png',
              menuShow: true
            }
          }
        ]
      }
    ]
  },
  {
    path: '/api',
    name: 'api',
    component: (resolve) => {
      require(['@/views/api/index.vue'], resolve)
    },
    meta: {
      title: 'router.api.title',
      name: 'router.api.name',
      desc: 'router.api.desc',
      icon: '',
      menuShow: true
    }
  },
  {
    path: '/service',
    name: 'service',
    component: (resolve) => {
      require(['@/views/service/index.vue'], resolve)
    },
    meta: {
      title: 'router.service.title',
      name: 'router.service.name',
      desc: 'router.service.desc',
      icon: '',
      menuShow: true
    },
    children: [
      {
        path: '/service/guide',
        name: 'guide',
        component: (resolve) => {
          require(['@/views/service/guide.vue'], resolve)
        },
        meta: {
          title: 'router.guide.title',
          name: 'router.guide.name',
          desc: 'router.guide.desc',
          icon: 'nav_icon_guide.png',
          menuShow: true
        }
      },
      {
        path: '/service/afterMarket',
        name: 'afterMarket',
        component: (resolve) => {
          require(['@/views/service/afterMarket.vue'], resolve)
        },
        meta: {
          title: 'router.afterMarket.title',
          name: 'router.afterMarket.name',
          desc: 'router.afterMarket.desc',
          icon: 'nav_icon_aftermarket.png',
          menuShow: true
        }
      },
      {
        path: '/service/download',
        name: 'download',
        component: (resolve) => {
          require(['@/views/service/download.vue'], resolve)
        },
        meta: {
          title: 'router.download.title',
          name: 'router.download.name',
          desc: 'router.download.desc',
          icon: 'nav_icon_download.png',
          menuShow: true
        }
      },
      {
        path: '/service/Q&A',
        name: 'question',
        component: (resolve) => {
          require(['@/views/service/question.vue'], resolve)
        },
        meta: {
          title: 'router.question.title',
          name: 'router.question.name',
          desc: 'router.question.desc',
          icon: 'nav_icon_Q&A.png',
          menuShow: true
        }
      }
    ]
  },
  {
    path: '/community',
    name: 'community',
    component: (resolve) => {
      require(['@/views/community/index.vue'], resolve)
    },
    meta: {
      title: 'router.community.title',
      name: 'router.community.name',
      desc: 'router.community.desc',
      icon: '',
      keepAlive: true,
      menuShow: true
    }
  },
  {
    path: '/community/newblog',
    name: 'newBlog',
    component: (resolve) => {
      require(['@/views/community/newBlog.vue'], resolve)
    },
    meta: {
      title: 'router.community.title',
      needPermission: true
    }
  },
  {
    path: '/community/blogdetail/:id',
    name: 'blogDetail',
    component: (resolve) => {
      require(['@/views/community/blogDetail.vue'], resolve)
    },
    meta: {
      title: 'router.community.title'
    }
  },
  {
    path: '/help',
    name: 'help',
    component: (resolve) => {
      require(['@/views/community/help.vue'], resolve)
    },
    meta: {
      title: 'router.help.title',
      name: 'router.help.name',
      desc: 'router.help.desc',
      icon: '',
      keepAlive: true,
      headerHide: true,
      footerHide: true
    }
  },
  {
    path: '/help/detail/:id',
    name: 'helpDetail',
    component: (resolve) => {
      require(['@/views/community/helpDetail.vue'], resolve)
    },
    meta: {
      title: 'router.help.title',
      name: 'router.help.name',
      desc: 'router.help.desc',
      icon: '',
      headerHide: true,
      footerHide: true
    }
  },

  {
    path: '/community/blogedit/:id',
    name: 'blogEdit',
    component: (resolve) => {
      require(['@/views/community/blogEdit.vue'], resolve)
    },
    meta: {
      title: 'router.community.title'
    }
  },
  {
    path: '/service/IFC16SInstall',
    name: 'IFC16SInstall',
    component: (resolve) => {
      require(['@/views/fm/installs/fc2_install.vue'], resolve)
    },
    meta: {
      title: 'router.IFC16SInstall.title'
    }
  },
  {
    path: '/service/ISM50Install',
    name: 'ISM50Install',
    component: (resolve) => {
      require(['@/views/fm/installs/sm_install.vue'], resolve)
    },
    meta: {
      title: 'router.ISM50Install.title'
    }
  },
  {
    path: '/service/IWS7Install',
    name: 'IWS7Install',
    component: (resolve) => {
      require(['@/views/fm/installs/ws_install.vue'], resolve)
    },
    meta: {
      title: 'router.IWS7Install.title'
    }
  },
  {
    path: '/service/IWS3Install',
    name: 'IWS3Install',
    component: (resolve) => {
      require(['@/views/fm/installs/ht_install.vue'], resolve)
    },
    meta: {
      title: 'router.IWS3Install.title'
    }
  },
  {
    path: '/service/FM1Install',
    name: 'FM1Install',
    component: (resolve) => {
      require(['@/views/fm/installs/fm1_install.vue'], resolve)
    },
    meta: {
      title: 'router.FM1Install.title'
    }
  },
  {
    path: '/service/FM2Install',
    name: 'FM2Install',
    component: (resolve) => {
      require(['@/views/fm/installs/fm2_install.vue'], resolve)
    },
    meta: {
      title: 'router.FM2Install.title'
    }
  },
  {
    path: '/service/IFC16Install',
    name: 'IFC16Install',
    component: (resolve) => {
      require(['@/views/fm/installs/fc1_install.vue'], resolve)
    },
    meta: {
      title: 'router.IFC16Install.title'
    }
  },
  {
    path: '/service/SolarPanelInstall',
    name: 'solarInstall',
    component: (resolve) => {
      require(['@/views/fm/installs/solar_install.vue'], resolve)
    },
    meta: {
      title: 'router.solarInstall.title'
    }
  },
  {
    path: '/service/FixedPoleInstall',
    name: 'FixedPoleInstall',
    component: (resolve) => {
      require(['@/views/fm/installs/fixedpole_install.vue'], resolve)
    },
    meta: {
      title: 'router.FixedPoleInstall.title'
    }
  },
  {
    path: '/user',
    name: 'user',
    component: (resolve) => {
      require(['@/views/user/index.vue'], resolve)
    },
    meta: {
      title: 'router.user.title',
      needPermission: true,
      footerHide: true
    }
  },
  {
    path: '/platform',
    name: 'platform',
    component: (resolve) => {
      require(['@/views/platform/index.vue'], resolve)
    },
    meta: {
      title: 'router.platform.title',
      needPermission: true,
      footerHide: true
    }
  },
  {
    path: '/user/home',
    name: 'userhome',
    component: (resolve) => {
      require(['@/views/community/userhome.vue'], resolve)
    },
    meta: {
      title: 'router.userhome.title',
      needPermission: true
    }
  },
  {
    path: '/404',
    name: '404',
    component: (resolve) => {
      require(['@/views/common/404.vue'], resolve)
    },
    meta: {
      title: 'router.title',
      headerHide: true,
      footerHide: true
    }
  },
  {
    path: '*',
    redirect: '/',
    meta: {
      title: 'router.home.title'
    }
  }
]

export default new Router({
  mode: 'history',
  base: '/',
  routes: constantRouterMap,
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js